import { LucideProps } from 'lucide-react'

export default function Figma(props: LucideProps) {
  return (
    <svg
      {...props}
      viewBox='0 0 1024 1280'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect rx='80' fill='white' />
      <path
        d='M512 640C512 614.805 522.009 590.641 539.825 572.825C557.641 555.009 581.804 545 607 545C632.196 545 656.359 555.009 674.175 572.825C691.991 590.641 702 614.805 702 640C702 665.196 691.991 689.359 674.175 707.175C656.359 724.991 632.196 735 607 735C581.804 735 557.641 724.991 539.825 707.175C522.009 689.359 512 665.196 512 640V640Z'
        stroke='currentColor'
        strokeWidth='35'
      />
      <path
        d='M322 830C322 804.804 332.009 780.641 349.825 762.825C367.641 745.009 391.804 735 417 735H512V830C512 855.196 501.991 879.359 484.175 897.175C466.359 914.991 442.196 925 417 925C391.804 925 367.641 914.991 349.825 897.175C332.009 879.359 322 855.196 322 830Z'
        stroke='currentColor'
        strokeWidth='35'
      />
      <path
        d='M512 355V545H607C632.196 545 656.359 534.991 674.175 517.175C691.991 499.359 702 475.196 702 450C702 424.804 691.991 400.641 674.175 382.825C656.359 365.009 632.196 355 607 355H512Z'
        stroke='currentColor'
        strokeWidth='35'
      />
      <path
        d='M322 450C322 475.196 332.009 499.359 349.825 517.175C367.641 534.991 391.805 545 417 545H512V355H417C391.805 355 367.641 365.009 349.825 382.825C332.009 400.641 322 424.804 322 450Z'
        stroke='currentColor'
        strokeWidth='35'
      />
      <path
        d='M322 640C322 665.196 332.009 689.359 349.825 707.175C367.641 724.991 391.804 735 417 735H512V545H417C391.804 545 367.641 555.009 349.825 572.825C332.009 590.641 322 614.805 322 640Z'
        stroke='currentColor'
        strokeWidth='35'
      />
    </svg>
  )
}
